import React from 'react';

import {
  AdditionalComments,
  AdditionalCommentsDetails,
} from 'src/dropInClinic/bridgeSubmissionReason/AdditionalComments';
import {
  PharmacyInfo,
  PharmacyInfoDetails,
} from 'src/dropInClinic/bridgeSubmissionReason/PharmacyInfo';
import {
  RefillRequest,
  RefillRequestDetails,
} from 'src/dropInClinic/bridgeSubmissionReason/RefillRequest';

type BridgeSubmissionReasonProps = {
  bridgeSubmissionDetails: AdditionalCommentsDetails & PharmacyInfoDetails & RefillRequestDetails;
};

const reasonComponents = [RefillRequest, PharmacyInfo, AdditionalComments];

export const BridgeSubmissionReason = ({
  bridgeSubmissionDetails,
}: BridgeSubmissionReasonProps) => {
  return (
    <ul>
      {reasonComponents.map(Component => (
        <Component key={Component.name} bridgeSubmissionDetails={bridgeSubmissionDetails} />
      ))}
    </ul>
  );
};
